import { actions as notificationActions } from '@saucelabs/sl-container-notifications';
import { actions } from '@saucelabs/sl-module-jobs';

export const stopJob = ({ id, username }) => async (dispatch) => {
  dispatch(actions.stopJob({ id, username }));
};

export const stopJobRdc = ({ id }) => async (dispatch) => {
  dispatch(actions.stopJobRdc({ id }))
    .catch((error) => {
      const defaultMessage = 'Session could not be stopped';
      const message = error.response.data?.message || defaultMessage;
      dispatch(notificationActions.notifyError(message));
    });
};
